/**
 * Header — Gudslip (Gudsport).
 * - Mide el alto del header → `--gudslip-header-h` (el hero se mete detrás con
 *   margin-top negativo → el header flota SOBRE el hero, y sigue siendo sticky).
 * - Carrito vacío: alterna .is-empty (muestra la animación "zzz").
 * - Menú móvil: abre/cierra el off-canvas [data-menu-toggle] → [data-mobile-menu].
 * Ver NOTAS-DESARROLLO.md §3.2.
 */
(function () {
  'use strict';

  function setHeaderHeight() {
    var header = document.querySelector('[data-gudslip-header]');
    if (!header) return;
    document.documentElement.style.setProperty('--gudslip-header-h', header.offsetHeight + 'px');

    // Los chips de rama (móvil/tablet) son `position: absolute` y FLOTAN sobre
    // lo que venga debajo: sin reservar su alto tapaban el H1 de cualquier
    // página sin hero (contacto, about, FAQ, 404…). Publicamos su alto y
    // `<main>` lo reserva en base.scss; el hero lo cancela con margen negativo.
    var branches = header.querySelector('.gudslip-header__branches');
    var h = 0;
    if (branches && getComputedStyle(branches).display !== 'none') {
      h = branches.offsetHeight + 8; // + el aire de debajo
    }
    document.documentElement.style.setProperty('--gudslip-branches-h', h + 'px');
  }

  function syncCart() {
    var cart = document.querySelector('.gudslip-header__cart');
    if (!cart) return;
    // Ruta localizada: en /es-es "/cart.js" a pelo consulta el carrito del
    // mercado RAÍZ (USD). `window.routes` lo emite layout/theme.liquid.
    var cartJsonUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    fetch(cartJsonUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c.item_count || 0;
        // La protección de envío no cuenta como producto en la burbuja.
        (c.items || []).forEach(function (i) {
          if (i.properties && i.properties._proteccion) n -= i.quantity;
        });
        if (n < 0) n = 0;
        cart.classList.toggle('is-empty', n === 0);
        var count = cart.querySelector('[data-cart-count]');
        if (count) count.textContent = n;
      })
      .catch(function () {});
  }

  // Menú móvil off-canvas.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('[data-mobile-menu]');
      if (nav) {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }
    // X dentro del panel: la hamburguesa queda TAPADA por el propio menú, así
    // que sin esto solo se podía cerrar tocando fuera.
    if (e.target.closest('[data-menu-close]')) {
      var openMenu = document.querySelector('[data-mobile-menu].is-open');
      if (openMenu) openMenu.classList.remove('is-open');
      var burger = document.querySelector('[data-menu-toggle]');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      return;
    }

    var openNav = document.querySelector('[data-mobile-menu].is-open');
    if (openNav && !openNav.contains(e.target)) openNav.classList.remove('is-open');
  });

  function boot() { setHeaderHeight(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight);
  document.addEventListener('cart:updated', syncCart);
  document.addEventListener('shopify:section:load', setHeaderHeight);
})();
